import { render, staticRenderFns } from "./RoomIssues.vue?vue&type=template&id=33460197&scoped=true&"
import script from "./RoomIssues.vue?vue&type=script&lang=ts&"
export * from "./RoomIssues.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33460197",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33460197')) {
      api.createRecord('33460197', component.options)
    } else {
      api.reload('33460197', component.options)
    }
    module.hot.accept("./RoomIssues.vue?vue&type=template&id=33460197&scoped=true&", function () {
      api.rerender('33460197', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/rooms/room/RoomIssues.vue"
export default component.exports